export { default as getScaledImageUrl } from './getScaledImageUrl';
